import React, { useState, useCallback } from 'react';
import { Handle, Position } from 'react-flow-renderer';


// Import CSS & assets
import './Nodes.css';
import close from '../../../../assets/ico/ico_close.svg';

const Node_Input_String_Long = ({ id, data }) => {

    const [nbRows, setNbRows] = useState("3");

    const handle_InputChange = useCallback((e) => {
        var value = null;
        var nb_rows = 3;
        if (e.target.value !== "") {
            value = "Node_Input_String_Long[" + e.target.value + "]";
            // Adapt nbRows
            var nb_lines = e.target.value.split("\n").length;
            nb_rows = Math.min(Math.max(3,nb_lines), 8);
        }
        setNbRows(nb_rows.toString());
        data.source_0 = value;
        data.handleChange(id, "source_0", value);
    }, []);

    return (
        <div id={"block_" + id} className="ruleeditor__node_container">
            <div className="ruleeditor__node_title">
                <div className="ruleeditor__node_title_label">{data.label}</div>
                <div className="ruleeditor__node_title_close"><img src={close} alt="close_block" onClick={() => (data.handleDelete(id))} /></div>
            </div>
            <div className="ruleeditor__node_center">
                <div className="ruleeditor__node_description">{data.description}</div>
                <div className="ruleeditor__node_body">
                    {/* <input className="ruleeditor__handle_source_input" type="text" onChange={(e) => { handle_InputChange(e) }} /> */}
                    <textarea className="ruleeditor__handle_source_inputMultiLine" id={id + "_Node_Input_String_Long"} rows={nbRows} onChange={(e) => { handle_InputChange(e) }}></textarea>
                    <div className={`ruleeditor__handle_source_type ${data.source[0].value !== null ? "ruleeditor__handle_type_valid" : ""}`}>{data.source[0].acceptance}</div>
                </div>
            </div>
            <Handle type="source" position={Position.Right} style={{ top: 'calc(100% - 11px - 17px)' }} id="source_0" />
        </div>
    );
};

export default Node_Input_String_Long;